import React from 'react';
import WaitFor, { HasLoadStatus, WaitForProps } from './WaitFor';

type ItemStore<T> = HasLoadStatus & {
    item: T;
};

type WaitForStoreItemProps<T> = Omit<WaitForProps, 'children' | 'operation'> & {
    store: ItemStore<T>;
    children?: (item: Exclude<Exclude<T, undefined>, null>) => React.ReactNode;
};

export default class WaitForStoreItem<T> extends React.Component<WaitForStoreItemProps<T>> {
    render() {
        const { children, store, ...props } = this.props;
        return (
            <WaitFor operation={store} {...props}>
                {() => {
                    const item = store.item;
                    if (item === undefined) {
                        return null;
                    }
                    if (item === null) return null;
                    return children?.(item as Exclude<Exclude<T, undefined>, null>);
                }}
            </WaitFor>
        );
    }
}
